const dfp = require('./module');

/**
 * @module dfp
 */
window.advert = window.advert || {};
window.advert.modules = window.advert.modules || [];
window.advert.modules.push(['dfp', dfp]);
